import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-scripts',
  templateUrl: './app-scripts.component.html',
  styleUrls: ['./app-scripts.component.scss']
})
export class AppScriptsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
